export enum SocialProvider {
  Facebook = 1,
  Google,
};